import { render, staticRenderFns } from "./PadLotNotes.vue?vue&type=template&id=edb09a30&"
import script from "./PadLotNotes.vue?vue&type=script&lang=js&"
export * from "./PadLotNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports